import { isArray, isString } from "lodash";
import { GetOrganizationConfiguration_organizationConfiguration } from "../operations/queries/__generated__/GetOrganizationConfiguration";

export interface AppConfiguration extends GetOrganizationConfiguration_organizationConfiguration {}

export interface AppConfigurationMultipleChoice {
  value: string;
  options: string[];
}

export const isMultipleChoiceOption = (value: unknown): value is AppConfigurationMultipleChoice => {
  if (!value || typeof value !== "object" || isArray(value)) {
    return false;
  }
  const candidate = value as { value?: unknown; options?: unknown };
  return isString(candidate.value) && isArray(candidate.options) && candidate.options.every((o) => isString(o));
};

export function filterWritableConfiguration(configuration: AppConfiguration): AppConfiguration {
  const filtered = {} as AppConfiguration;

  for (const key of Object.keys(configuration) as Array<keyof AppConfiguration>) {
    if (key !== "__typename") {
      const config = configuration[key];
      // Ensure config is an object and has the readOnly property
      if (typeof config === "object" && config !== null && "readOnly" in config && !config.readOnly) {
        const { readOnly, ...rest } = config; // Exclude readOnly property
        (filtered as any)[key] = rest;
      }
    }
  }

  return filtered;
}
